var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Integration',_vm._g(_vm._b({},'Integration',{ ..._vm.$attrs, reference: { onModel: 'Page', ref: _vm.$route.params.id } },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }